import React from 'react';
import { Container, Grid } from 'semantic-ui-react';
import CountDown from '@redturtle/iovisit-theme/components/Blocks/CountDown/CountDown';
import cx from 'classnames';

const Body = ({ data }) => {
  return (
    <div
      className={cx('block count_down body-block', {
        'bg-block': data.showBg,
      })}
    >
      <Container>
        <Grid verticalAlign="middle" centered>
          {(data.title || data.subtitle) && (
            <Grid.Column tablet={12} computer={4}>
              <div className="count-down-text">
                {data.title && <h2>{data.title}</h2>}
                {data.subtitle && <p className="block">{data.subtitle}</p>}
              </div>
            </Grid.Column>
          )}
          <Grid.Column
            tablet={12}
            computer={8}
            className={cx({ 'show-title': data.title || data.subtitle })}
          >
            <CountDown
              end={data.endDate}
              showHours={data.showHours}
              showMinutes={data.showMinutes}
              showSeconds={data.showSeconds}
            />
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};

export default Body;
